import * as styles from './index.module.scss';
import { observer } from 'mobx-react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Clickable from '../../../ui/Clickable';
import Icon from '../../../ui/Icon';
import React from 'react';
import { $class } from '../../../../utils';

const Nav = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const navButtons = [
    { icon: 'fi-rr-region-pin-alt', link: 'zoning' },
    { icon: 'fi-rr-rectangle-vertical-history', link: 'archive' },
    { icon: 'fi-rr-note', link: 'journal' },
    { icon: 'fi-rr-chart-histogram', link: 'couriers' },
    { icon: 'fi-rr-corporate-alt', link: 'organizations' },
  ];

  return (
    <div className={styles.nav}>
      <Clickable
        className={$class(styles.navButton, [
          styles.active,
          location.pathname === `/workspaces/new/${id}` ||
            location.pathname === `/workspaces/new/${id}/`,
        ])}
        onClick={() => navigate(`/workspaces/new/${id}`)}
      >
        <Icon slug="fi-rr-box-circle-check" />
      </Clickable>

      {navButtons.map((button) => (
        <Clickable
          key={button.link}
          className={$class(styles.navButton, [
            styles.active,
            location.pathname === `/workspaces/new/${id}/${button.link}`,
          ])}
          onClick={() => navigate(`/workspaces/new/${id}/${button.link}`)}
        >
          <Icon slug={button.icon} />
        </Clickable>
      ))}
    </div>
  );
};

export default observer(Nav);
